import { render, staticRenderFns } from "./VBeneficiaries.vue?vue&type=template&id=6a1da230"
import script from "./VBeneficiaries.vue?vue&type=script&lang=js"
export * from "./VBeneficiaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports